<template>
  <div class="order-item">
    <b-container class="bv-example-row">
      <b-row>
        <b-col><span class="select" :class="{'selected':item.checked}" @click="checkItem" /></b-col>
        <b-col>{{ item.commonName }}<br>{{ item.name }}</b-col>
        <b-col>{{ item.norm }}</b-col>
        <b-col>{{ item.manufacturer }}</b-col>
        <b-col>{{ item.licenseNumber }}</b-col>
        <b-col>{{ item.largeScale }}</b-col>
        <b-col>{{ item.inventory }}</b-col>
        <b-col>{{ item.basicUnit }}</b-col>
        <b-col>{{ item.expiryTime }}</b-col>
        <b-col>{{ item.showPrice }}</b-col>
        <b-col class="item-num">
          <span class="discount" @click="discount">-</span>
          <input v-model="item.num" type="text" @blur="change">
          <span class="add" @click="add">+</span>
        </b-col>
        <b-col>{{ countPrice }}</b-col>
        <b-col>
          <a href="javascript:void(0);" class="delete" @click="remove">删除</a>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    countPrice: function () {
      let count = 0
      count = this.item.num * this.item.showPrice
      return count.toFixed(2)
    }
  },
  mounted () {
    console.log(this.item, 'items')
  },
  methods: {
    change () {
      // input框失去焦点改变商品数量
      this.item.num = Number(this.item.num)
      const result = this.dealItemNum(this.item.num, this.item.inventory)
      if (result === 0) {
        this.item.num = 1
      } else if (result === -1) {
        this.item.num = this.item.inventory
      }
      this.addTocart()
    },
    discount () {
      // 商品数量减少
      this.item.num--
      const result = this.dealItemNum(this.item.num, this.item.inventory)
      if (result === 0) {
        this.item.num = 1
        return
      }
      this.addTocart()
    },
    showToast (str) {
      this.$bvToast.toast(str, {
        title: '加入购物车',
        autoHideDelay: 2000
      })
    },
    add () {
      // 商品数量增加
      this.item.num++
      const result = this.dealItemNum(this.item.num, this.item.inventory)
      if (result === -1) {
        this.item.num = this.item.inventory
        return
      }
      this.addTocart()
    },
    addTocart () {
      // 添加到购物车
      const item = {
        id: this.item.id,
        num: this.item.num
      }
      this.$store.commit('addTocart', item)
    },
    dealItemNum (count, inventory) {
      // 购物车数量为0或超出库存时
      let result = 1
      if (count === 0) {
        this.showToast('购买数量不能为0',)
        result = 0
      } else if (count > inventory) {
        this.showToast('商品库存不足')
        result = -1
      }
      return result
    },
    checkItem () {
      // 勾选商品
      console.log('item id l==========')
      console.log(this, 'llthis.')
      console.log(this.item, 'itemssssss')

      this.$emit('selectItem', this.item.id)
    },
    remove () {
      // 删除商品
      this.$store.commit('removeItem', this.item.id)
      this.$emit('removeItem', this.item.id)
    }
  }
}
</script>
<style>
  .order-item .col {
    height: 40px;
    font-weight: normal;
    line-height: 1.5;
    vertical-align: middle;
    font-size: 0.75rem;
    flex-basis: auto;
    padding: 0;
    display: table-cell;
  }
  .order-item .col a.delete {
    color: #f50a0a;
    text-decoration: none;
  }
  .order-item .row {
    border-bottom: 3px solid #f8b551;
    flex-wrap: nowrap;
    display: table;
  }
  .order-item .select {
    margin-left: 18px;
  }
  .order-item .col:nth-of-type(1) {
    width:88px;
  }
  .order-item .col:nth-of-type(2) {
    width:132px;
  }
  .order-item .col:nth-of-type(3) {
    width:82px;
  }
  .order-item .col:nth-of-type(4) {
    width:112px;
  }
  .order-item .col:nth-of-type(5) {
    width:130px;
  }
  .order-item .col:nth-of-type(6) {
    width:56px;
  }
  .order-item .col:nth-of-type(7) {
    width:64px;
  }
  .order-item .col:nth-of-type(8) {
    width:40px;
  }
  .order-item .col:nth-of-type(9) {
    width:130px;
  }
  .order-item .col:nth-of-type(10) {
    width:44px;
  }
  .order-item .col:nth-of-type(11) {
    width:130px;
  }
  .order-item .col:nth-of-type(12) {
    width:106px;
  }
  .order-item .col:nth-of-type(13) {
    width:102px;
  }
  .order-item .item-num span,
  .order-item .item-num input{
    height: 25px;
    text-align: center;
    vertical-align: middle;
    display: inline-block;
    border: 1px solid #ccc;
  }
  .order-item .item-num span {
    cursor: pointer;
    width: 22px;
  }
  .item-num .discount {
    border-right: 0;
  }
  .item-num input {
    width: 70px;
  }
  .item-num .add {
    border-left: 0;
  }
</style>
